import React, { useState } from 'react';
import { Button } from 'antd';
import { MessageOutlined } from '@ant-design/icons';
import { FeedbackForm } from 'pages/Feedback/components';
import { FeedbackRequestDto } from 'shared/api';
import { useFeedback } from 'pages/Feedback/hooks/useFeedback';

import { IStore } from 'app/providers/Store/model/store';
import { useSelector } from 'react-redux';
import { showSuccess } from 'shared/utils';
import styles from './FloatingFeedbackButton.module.scss';

export const FloatingFeedbackButton: React.FC = () => {
  const [isFormOpen, setIsFormOpen] = useState(false);
  const { createNewFeedback } = useFeedback();
  const user = useSelector((state: IStore) => state.userSlice.user);

  const handleSubmit = async (data: FeedbackRequestDto) => {
    const result = await createNewFeedback({ ...data, userId: user.id });
    if (result.success) {
      setIsFormOpen(false);
      showSuccess({
        title: 'Спасибо за ваш отзыв!',
      });
    }
  };

  const handleCancel = () => {
    setIsFormOpen(false);
  };

  return (
    <>
      <Button
        type="primary"
        shape="circle"
        size="large"
        icon={<MessageOutlined style={{ fontSize: 28 }} />}
        className={styles.floatingButton}
        onClick={() => setIsFormOpen(true)}
        title="Оставить отзыв"
      />

      <FeedbackForm
        isOpen={isFormOpen}
        editingFeedback={null}
        isEditing={false}
        onSubmit={handleSubmit}
        onCancel={handleCancel}
      />
    </>
  );
};
